import React, { useContext, useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import MsgUtils from '../Tools/MsgUtils';
import UtilsBufer from '../Tools/UtilsBufer';
import DateConverter from '../Tools/DateConverter';
import { ContextGloball } from '../Context/ContextGlobal';
import VerPermiso from '../Tools/VerificarPermisos';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
const server = process.env.REACT_APP_SERVER;

function PrincipalSugerencias() {
  const { loading, setLoading } = useContext(ContextGloball)
  const [sugerencias, setSugerencias] = useState([]);
  const [fechaIni, setFechaIni] = useState('');
  const [fechaFin, setFechafin] = useState('');
  const [selectItem, setSelectItem] = useState({});
  const [modalShow, setModalShow] = useState(false);
  const [respuesta, setRespuesta] = useState('');
  const [sucursales, setSucursales] = useState([]);
  const [idSucursal, setIdSucursal] = useState(-2);
  function mostrarDetalle(dato) {
    setSelectItem(dato);
    setModalShow(true);
  }
  function hayFiltro(suc) {
    if (idSucursal == -2) {
      return true;
    } else {
      return parseInt(idSucursal) == parseInt(suc);
    }
  }
  function exportarExcel() {
    var datos = []
    if (idSucursal == -2) {
      datos = sugerencias
    } else {
      datos = sugerencias.filter((item) => item.ID_SUCURSAL == idSucursal);
    }
    var resultados = []
    for (var valor of datos) {
      var itemV = {
        'FECHA': DateConverter.formatoFecha(valor.FECHA),
        'SUCURSAL': valor.ID_SUCURSAL == -1 ? 'GENERAL' : valor.NAMESUCURSAL,
        'CELULAR': valor.NUMERO,
        'Sugerencia/Queja': UtilsBufer.getText(valor.SUGERENCIA),
        'REVISADO POR': valor.NOMBREX,
        'RESPUESTA': UtilsBufer.getText(valor.REVISION),
        'FECHA RESPUESTA': DateConverter.formatoFecha(valor.REVISION_FECHA)
      }
      resultados.push(itemV)
    }
    const worksheet = XLSX.utils.json_to_sheet(resultados);
    worksheet['!cols'] = [{ wch: '20' }, { wch: '10' }, { wch: '10' }, { wch: '50' }, { wch: '30' }, { wch: '50' }, { wch: '20' }];
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Reporte");
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    var date = DateConverter.getFechHoyFormaroDefault()
    saveAs(blob, `reporteSugerenciaQueja${date}.xlsx`);
  }
  function guardarRespuesta() {
    //setLoading(true);
    fetch(`${server}/moduloSug/saveRespuesta`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        idEmpleado: JSON.parse(localStorage.getItem('__react_session__')).idSession,
        respuesta: respuesta,
        idSugerencia: selectItem.ID_SUGERENCIA
      })
    })
      .then(res => res.json())
      .then(data => {
        setModalShow(false);
        //setLoading(false);
        if (data.ok) {
          console.log(data.ok);
          setSelectItem({});
          MsgUtils.msgCorrecto(data.ok);
          setSugerencias([]);
          document.getElementById('btnBuscar').click()
        } else {
          MsgUtils.msgError(data.error);
        }
      })
      .catch(err => MsgUtils.msgError(err));
  }
  function getSugerencias() {
    setLoading(true);
    fetch(`${server}/moduloSug/getSugerencias`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        regional: 'regional',
        fechaIni, fechaFin
      })
    })
      .then(res => res.json())
      .then(data => {
        setLoading(false);
        if (data.ok) {
          console.log(data.ok);
          setSugerencias(data.ok);
        } else {
          MsgUtils.msgError(data.error);
        }
      })
      .catch(err => MsgUtils.msgError(err));
  }
  useEffect(() => {
    if (sucursales.length == 0) {
      fetch(`${server}/sqlComun/getSucursales`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          regional: JSON.parse(localStorage.getItem('__react_session__')).regional
        })
      })
        .then(res => res.json())
        .then(data => {
          if (data.ok) {
            setSucursales(data.ok);
          } else {
            MsgUtils.msgError(data.error);
          }
        })
        .catch(err => console.log(err));
    }
  }, [sugerencias])
  return (
    <>
      <div className='container-fluid bg-dark bg-gradient py-1'>
        <div className='row row-cols g-1 gx-0 gy-1' style={{ paddingRight: '40px' }}>
          <div className='col' style={{ maxWidth: '190px', minWidth: '190px' }}>
            <div className="input-group input-group-sm" >
              <span className="input-group-text bg-transparent text-light"
                style={{ border: 'none' }}
              >Fecha Inicial</span>
              <input type="date" className="form-control" placeholder="12-03-12"
                value={fechaIni} onChange={(e) => setFechaIni(e.target.value)} />
            </div>
          </div>
          <div className='col' style={{ maxWidth: '190px', minWidth: '190px' }}>
            <div className="input-group input-group-sm" >
              <span className="input-group-text bg-transparent text-light"
                style={{ border: 'none' }} >Fecha Final</span>
              <input type="date" className="form-control" placeholder="12-03-12"
                value={fechaFin} onChange={(e) => setFechafin(e.target.value)} />
            </div>
          </div>
          <div className='col' style={{ maxWidth: '180px', minWidth: '180px' }}>
            <div className="input-group input-group-sm">
              <span className="input-group-text bg-transparent text-light"
                style={{ border: 'none' }} >Sucursal</span>
              <select className="form-select" value={idSucursal} onChange={(e) => setIdSucursal(e.target.value)}>
                <option value={-2}>TODOS</option>
                <option value={-1}>GENERAL</option>
                {sucursales.map((item, index) => {
                  return (<option value={item.ID_SUCURSAL} key={index}>{item.SUCURSAL}</option>)
                })}
              </select>
            </div>
          </div>
          <div className='col' style={{ maxWidth: '100px', minWidth: '100px' }}>
            <button className='btn btn-sm btn-success w-100' id='btnBuscar'
              onClick={() => getSugerencias()}><i className="fa-solid fa-rotate-right"></i> Buscar</button>
          </div>
          <div className='col' style={{ maxWidth: '100px', minWidth: '100px' }}>
            <button className='btn btn-sm btn-info w-100' onClick={() => exportarExcel()}>
              <i className="fa-solid fa-file-excel"></i> Excel</button>
          </div>
        </div>
      </div>
      <div className='table-responsive'>
        <table className="table table-striped table-dark">
          <thead>
            <tr>
              <th >FECHA</th>
              <th >SUCURSAL</th>
              <th >SUGERENCIA</th>
              <th >REVISADO POR</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {sugerencias.map((item, index) => {
              if (hayFiltro(item.ID_SUCURSAL)) {
                return (
                  <tr key={index}>
                    <td className='col-2'>{DateConverter.formatoFecha(item.FECHA)}</td>
                    <td>{item.NAMESUCURSAL != null ? item.NAMESUCURSAL : 'GENERAL'}</td>
                    <td>{UtilsBufer.getText(item.SUGERENCIA).substring(0, 10)} ...</td>
                    <td className='col-5'>
                      <div className='container-fluid'>
                        <div className='row row-cols-1 row-cols-md-2 g-0'>
                          <div className='col col-sm-12 col-md-2 text-center'>
                            {UtilsBufer.getFotoCard(item.FOTO, 40)}
                          </div>
                          <div className='col col-sm-12 col-md-10 text-start'>
                            {item.NOMBREX}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className='col-2'>
                      <button className='btn btn-success' onClick={() => mostrarDetalle(item)}>
                        Ver
                      </button>
                    </td>
                  </tr>
                )
              }
            })}
          </tbody>
        </table>
      </div>
      <Modal show={modalShow} onHide={() => setModalShow(false)}
        size='xl'
        aria-labelledby="contained-modal-title-vcenter"
        contentClassName='bg-dark bg-gradient'>
        <Modal.Header closeButton closeVariant='white' bsPrefix='modal-header m-0 p-0 px-2'>
          <Modal.Title>
            <div className='text-light'>Detalle </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body bsPrefix='modal-body m-0 p-0 px-2'>
          <div className='container-fluid mb-2'>
            <div className='row row-cols-sm-1 row-cols-md-2 g-1'>
              <div className='col-12 col-sm-12 col-md-6'>
                <div className='w-100 py-2'>
                  <div className='bg-secondary text-light text-center'>Sugerencia</div>
                  <div className='text-light'>
                    Celular: {selectItem.NUMERO}
                  </div>
                  <div className='text-light'>
                    Fecha: {DateConverter.formatoFecha(selectItem.FECHA)}
                  </div>
                  <div className='text-light'>
                    Para SUCURSAL: {selectItem.NAMESUCURSAL !== null ? selectItem.NAMESUCURSAL : 'GENERAL'}
                  </div>
                  <textarea className='form-control w-100'
                    disabled={true} value={UtilsBufer.getText(selectItem.SUGERENCIA)} style={{ height: '160px' }} />
                </div>
              </div>
              <div className='col-12 col-sm-12 col-md-6 py-2'>
                <div className='container-fluid'>
                  <div className='bg-secondary text-light text-center'>
                    {(selectItem.REVISADO_POR == undefined || selectItem.REVISADO_POR == null) ? 'RESPONDER' : 'Revisado Por'}
                  </div>
                </div>
                {VerPermiso.validarPermiso('47') && (selectItem.REVISADO_POR == undefined || selectItem.REVISADO_POR == null) &&
                  <div className='container-fluid py-2'>
                    <button className='btn btn-sm btn-success w-100' onClick={() => guardarRespuesta()}> Guardar</button>
                  </div>
                }
                {(selectItem.REVISADO_POR != undefined || selectItem.REVISADO_POR != null) &&
                  <div className='container-fluid'>
                    <div className='row row-cols-md-2 g-0'>
                      <div className='col-3 text-center'>
                        {UtilsBufer.getFotoCard(selectItem.FOTO, 40)}
                      </div>
                      <div className='col-9 text-light'>
                        {selectItem.NOMBREX}
                      </div>
                    </div>
                  </div>}
                <div className='container-fluid'>
                  <div className='text-light'>
                    Fecha Revisión: {DateConverter.formatoFecha(selectItem.REVISION_FECHA)}
                  </div>
                  {VerPermiso.validarPermiso('47') && (selectItem.REVISADO_POR !== undefined && selectItem.REVISADO_POR !== null) && <textarea className='form-control w-100'
                    disabled={true} value={UtilsBufer.getText(selectItem.REVISION)} style={{ height: '120px' }} />}
                  {VerPermiso.validarPermiso('47') && (selectItem.REVISADO_POR == undefined || selectItem.REVISADO_POR == null) && <textarea className='form-control w-100'
                    value={respuesta} style={{ height: '120px' }} onChange={(e) => setRespuesta(e.target.value.toUpperCase())} />}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default PrincipalSugerencias